import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

import Swiper, { Navigation } from 'swiper' //eslint-disable-line
import 'swiper/css' //eslint-disable-line
import 'swiper/css/navigation' //eslint-disable-line

class Technology {
  constructor() {
    if (!document.querySelector('.c-technology-video')) return
    this.init()
  }

  async init() {
    this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1

    /*
    Inconsistent codec support on Firefox
    https://muffinman.io/blog/scrubbing-videos-using-javascript/
    */
    if (this.isFirefox) {
      const mp4s = document.querySelectorAll('source[type="video/mp4"]')
      mp4s.forEach((mp4) => {
        mp4.remove()
      })
    }

    this.video = document.querySelector('#technology-player')
    this.video.load()

    /* IOS */
    window.addEventListener(
      'touchstart',
      () => {
        this.video.play()
        this.video.pause()
      },
      { once: true },
    )

    const slider = document.querySelector('.c-technology-slider')
    const container = slider.querySelector('.swiper')

    const prevEl = slider.querySelector('.c-slider__arrow--left')
    const nextEl = slider.querySelector('.c-slider__arrow--right')
    this.slider = new Swiper(container, {
      modules: [Navigation],
      navigation: {
        nextEl,
        prevEl,
      },
      centeredSlides: true,
      loop: true,
      draggable: true,
    })

    const checker = setInterval(() => {
      if (this.video.readyState > 0) {
        this.setTimeline()
        this.setScrollTrigger()
        clearInterval(checker)
      }
    }, 50)
  }

  setTimeline() {
    this.animation = gsap.timeline({ ease: 'none' })

    const mm = gsap.matchMedia()
    mm.add('(max-width: 899px)', () => {
      const intro = gsap.timeline().set(this.video, {
        opacity: 1,
      })
      this.animation.add(intro, 0)

      return () => {
        gsap.set(this.video, { clearProps: 'all' })
      }
    })

    const modals = document.querySelectorAll('.c-technology-modal')
    modals.forEach((modal, index) => {
      const { start, durationDesktop, durationMobile } = modal.dataset

      const duration = window.innerWidth >= 900 ? durationDesktop : durationMobile
      const title = modal.querySelector('.c-technology-modal__title')
      const description = modal.querySelector('.c-technology-modal__description')

      const tl = gsap.timeline({})

      tl.to([title, description], {
        opacity: 1,
        y: 20,
        stagger: 0.1,
        duration: 0.3,
      })
      tl.add(gsap.set(modal, { pointerEvents: 'all' }), `>${+duration}`)
      tl.to(
        [title, description],
        {
          opacity: 0,
          y: 0,
          stagger: 0.1,
          duration: 0.3,
        },
        `>${+duration}`,
      )
      tl.add(gsap.set(modal, { pointerEvents: 'none' }), `>${+duration}`)

      this.animation.add(tl, +start)
    })

    const videoTL = gsap.timeline({ ease: 'none' })
    videoTL.fromTo(
      this.video,
      {
        currentTime: 0,
      },
      {
        currentTime: this.video.duration,
        duration: this.video.duration,
      },
    )
    this.animation.add(videoTL, 0)
  }

  setScrollTrigger() {
    ScrollTrigger.create({
      trigger: '.c-technology-video',
      start: 'top 50%',
      end: 'bottom 50%',
      animation: this.animation,
      scrub: true,
    })
  }
}

export default Technology
